export default __webpack_public_path__ + "static/media/wav.278c07d0.svg";